import * as React from "react"
import { Tabs as TabsPrimitive } from "radix-ui"
import { cn } from "../../lib/utils"

const Tabs = TabsPrimitive.Root

function TabsList({
  className,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.List>) {
  return (
    <TabsPrimitive.List
      className={cn(
        "inline-flex items-center gap-1 bg-surface-container-low p-1 rounded-lg",
        className
      )}
      {...props}
    />
  )
}

function TabsTrigger({
  className,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.Trigger>) {
  return (
    <TabsPrimitive.Trigger
      className={cn(
        "inline-flex items-center justify-center whitespace-nowrap px-3 py-1.5 text-xs font-bold uppercase tracking-widest text-on-surface-variant transition-all duration-150 ease-[cubic-bezier(0.4,0,0.2,1)] cursor-pointer rounded-md disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-surface-container-highest data-[state=active]:text-on-surface",
        className
      )}
      {...props}
    />
  )
}

function TabsContent({
  className,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.Content>) {
  return (
    <TabsPrimitive.Content
      className={cn("mt-3 outline-none", className)}
      {...props}
    />
  )
}

export { Tabs, TabsList, TabsTrigger, TabsContent }
